var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleBoothLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.2 41.5",
    style: {
      enableBackground: "new 0 0 100.2 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,16.9L9.1,15c1,0.9,2.3,1.5,3.7,1.5c1.1,0,1.8-0.4,1.8-1.2l0,0c0-0.7-0.4-1-2.5-1.6C9.6,13.1,8,12.4,8,10 l0,0c0-2.2,1.8-3.7,4.3-3.7c1.7,0,3.3,0.5,4.6,1.6l-1.4,2c-0.9-0.7-2-1.1-3.2-1.2c-1,0-1.6,0.5-1.6,1.1l0,0c0,0.8,0.5,1.1,2.7,1.6 c2.5,0.6,3.9,1.6,3.9,3.7l0,0c0,2.4-1.9,3.8-4.5,3.8C10.8,18.9,8.9,18.2,7.5,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,6.4h2.7v12.4H24V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,6.4h2.9l3.2,5.2l3.2-5.2h2.9v12.4H43v-8.1L39.5,16h-0.1L36,10.7v8h-2.7V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,6.4h5c3,0,4.7,1.7,4.7,4.3l0,0c0,2.9-2.2,4.3-5,4.3h-2.1v3.7h-2.7V6.4z M57.4,12.6 c1.1,0.1,2-0.6,2.1-1.7c0-0.1,0-0.1,0-0.2l0,0c0-1.2-0.8-1.9-2.2-1.9h-2.1v3.8L57.4,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.5,6.4h2.7v9.9h6.2v2.5h-8.9V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,6.4h9.3v2.4h-6.6v2.5h5.8v2.4h-5.8v2.6h6.7v2.4h-9.4V6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,22.4h5.7c1.2-0.1,2.3,0.3,3.2,1.1c0.6,0.6,0.9,1.3,0.9,2.1l0,0c0,1.1-0.6,2.2-1.6,2.7 c1.4,0.3,2.3,1.6,2.3,3l0,0c0,2.3-1.8,3.4-4.6,3.4H7.7V22.4z M14.8,26c0-0.8-0.6-1.3-1.8-1.3h-2.7v2.6h2.5 C14,27.3,14.8,27,14.8,26L14.8,26z M13.4,29.6h-3.1v2.7h3.2c1.2,0,1.9-0.4,1.9-1.3l0,0C15.4,30.1,14.8,29.6,13.4,29.6L13.4,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,28.6L24.8,28.6c0-3.5,2.9-6.4,6.4-6.4c0.1,0,0.1,0,0.2,0c3.5-0.1,6.4,2.6,6.5,6.1c0,0.1,0,0.2,0,0.2 l0,0c0,3.5-2.9,6.4-6.4,6.4c-0.1,0-0.1,0-0.2,0c-3.5,0.1-6.4-2.6-6.5-6.1C24.8,28.8,24.8,28.7,24.8,28.6z M35.1,28.6L35.1,28.6 c0.1-2.1-1.6-3.8-3.6-3.9c0,0-0.1,0-0.1,0c-2,0-3.7,1.7-3.7,3.7c0,0.1,0,0.1,0,0.2l0,0c-0.1,2.1,1.6,3.8,3.6,3.9c0,0,0.1,0,0.1,0 c2,0,3.7-1.6,3.7-3.7C35.1,28.7,35.1,28.6,35.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.7,28.6L44.7,28.6c0.1-3.6,3.2-6.5,6.8-6.3c3.4,0.1,6.2,2.9,6.3,6.3l0,0c-0.1,3.6-3.2,6.5-6.8,6.3 C47.6,34.8,44.9,32,44.7,28.6z M55,28.6L55,28.6c0.1-2.1-1.5-3.8-3.6-3.9c0,0-0.1,0-0.1,0c-2,0-3.7,1.6-3.7,3.7c0,0.1,0,0.1,0,0.2 l0,0c-0.1,2.1,1.6,3.8,3.6,3.9c0,0,0.1,0,0.1,0c2,0,3.7-1.7,3.7-3.7C55,28.7,55,28.6,55,28.6L55,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.9,24.9h-3.8v-2.5h10.2v2.5h-3.8v9.9h-2.7V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.1,22.4h2.7v4.9h5v-4.9h2.7v12.4h-2.7v-5h-5v5h-2.7V22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v41.2l100.2,0.2V0H0z M98.1,39h-96V2.1h96V39z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleBoothLogoWhite);
export default __webpack_public_path__ + "static/media/simple-booth-logo-white.6d1ac068a7362acc3b01deecd998e098.svg";
export { ForwardRef as ReactComponent };